export const textToolbarFormats = ['bold', 'italic', 'underline', 'strike'];
